import _ from "lodash";
export function isDefined(value) {
    return value !== undefined && value != null;
}
export function isArrayDefined(value) {
    return (_.isEmpty(value) === false && isDefined(value) && typeof value != "string");
}
